import LoginForm1 from "../../../../content/blog/how-to-create-inclusive-feedback-in-spas/login-form-1.jsx";
import LoginForm2 from "../../../../content/blog/how-to-create-inclusive-feedback-in-spas/login-form-2.jsx";
import * as React from 'react';
export default {
  LoginForm1,
  LoginForm2,
  React
};